
import React from "react";
import * as ReactRouterDom from "react-router-dom";
import { Classname, DateHelper } from "@rivtn/noseur";
import { Utils } from "../../../../../utils";
import styles from "../../assets/style.module.css";
import { i18nManager } from "../../../../../i18n";
import { IMember, IProfileWebsite } from "../../../../../services";
import { activeMedia, pagePath, splitName, visiblePages } from "../../helpers";

export interface FooterProps {
    basePath: string;
    profile?: IMember;
    website: IProfileWebsite;
}

function Footer({ website, basePath, profile }: FooterProps) {

    const labels = i18nManager.Labels;
    const logo = activeMedia(website, "LOGO");
    const today = DateHelper.getStartOfDay();
    const { last } = splitName(website.display_name);
    const owner = website.owns_copyright ? website.display_name : labels.omnehost;
    const sponsors = website.home_settings?.show_sponsors ? (website.sponsors ?? []) : [];
    const socials = Object.entries(website.owns_copyright ? (website.member.social_accounts ?? {}) : { ...Utils.OMNEHOST_SOCIALS, ...(website.member.social_accounts ?? {}) });
    const [searchParams] = ReactRouterDom.useSearchParams(window.location.search);
    const dashboardUrl = process.env.REACT_APP_OMNEHOST_DASHBOARD_URL ?? "http://127.0.0.1:3901";
    const footerLinks: React.ReactNode[] = [
        ...visiblePages(website).map(([page, pageSettings]) => (
            <ReactRouterDom.NavLink end key={page} to={{ pathname: pagePath(basePath, page), search: searchParams.toString() }}
                className={({ isActive }) => Classname.build({ [styles["active"]]: isActive })}>{pageSettings.label}</ReactRouterDom.NavLink>
        )),
        ...(website.owns_copyright ? [] : [
            <ReactRouterDom.NavLink key="dashboard" target="_blank" to={dashboardUrl}>{profile ? labels.auth.dashboard : labels.auth.sign_in}</ReactRouterDom.NavLink>,
            ...labels.footer.map((f) => (<ReactRouterDom.NavLink key={f.label} target="_blank" to={f.location}>{f.label}</ReactRouterDom.NavLink>)),
        ]),
    ];

    return (<>
        <div className={styles["partners"]}>
            <div className={Classname.build(styles["container"], styles["partners-inner"])}>
                <div className={styles["partners-brand"]}>
                    {logo ? (<img src={logo} alt={website.display_name} />) : last}
                </div>
                <div className={styles["partners-logos"]}>
                    {sponsors.map((s) => (<img key={s} src={s} alt="" loading="lazy" />))}
                </div>
                <div className={styles["socials"]}>
                    {socials.map(([social, username]) => (
                        <ReactRouterDom.NavLink key={social} target="_blank" to={Utils.getSocialLink(social, username)} className={styles["social"]} aria-label={social}><i className={Utils.getSocialIcon(social)} /></ReactRouterDom.NavLink>
                    ))}
                </div>
            </div>
        </div>

        <footer className={styles["footer"]}>
            <div className={styles["container"]}>
                <div>© {today.getFullYear()} {owner}. {labels.landing.all_r_reserved}</div>
                <div className={styles["footer-links"]}>
                    {footerLinks.map((link, i) => (<React.Fragment key={i}>
                        {i > 0 && (<span className={styles["footer-sep"]}>|</span>)}
                        {link}
                    </React.Fragment>))}
                </div>
                <div className={styles["footer-note"]}>{website.owns_copyright ? website.profile_detail : labels.omnehost_detail}</div>
            </div>
        </footer>
    </>);
}

export default Footer;
